const formatLongPrice = price => {
  return new Intl.NumberFormat('ru-RU').format(Number.parseInt(price, 10));
};

export default formatLongPrice;
